import { useState, Fragment, useEffect } from "react";
import {
  Card,
  Col,
  CardTitle,
  CardBody,
  CardImg,
  Row,
  Collapse,
} from "reactstrap";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  ChangeLockStatusForModuleForStudent,
  ChangeLockStatusForModuleForClass,
  ChangeLockStatusForEntireCourseForMultipleStudents,
} from "../../actions/teacherMutations";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";
import { BeatLoader } from "react-spinners";
import { CTooltip } from "@coreui/react";
import { injectIntl } from "react-intl";

const ModuleLocker = ({ level, courses, currentLevelId, students, intl }) => {
  const [modulesCollapseOpen, setModulesCollapseOpen] = useState([]);
  const [collapsed, setCollapsed] = useState([]);
  const [coursesLoadingLock, setCoursesLoadingLock] = useState([]);
  const [coursesLockStatus, setCoursesLockStatus] = useState([]);
  const [toggleUpdateCourseLockStatus, setToggleUpdateCourseLockStatus] =
    useState(false);

  const queryClient = useQueryClient();
  const changeLockStatusForModuleForClass = useMutation(
    ChangeLockStatusForModuleForClass
  );
  const changeLockStatusForModuleForStudent = useMutation(
    ChangeLockStatusForModuleForStudent
  );
  const changeLockStatusForEntireCourseForMultipleStudents = useMutation(
    ChangeLockStatusForEntireCourseForMultipleStudents
  );

  useEffect(() => {
    if (courses) {
      const lockStatuses = {
        locked: "locked",
        partiallyLocked: "partiallyLocked",
        unlocked: "unlocked",
      };
      const tempCoursesLockStatus = [];
      courses.forEach((c) => {
        const courseToAdd = { courseId: c.id, isLocked: lockStatuses.unlocked };
        if (
          c.modules
            .filter((m) => !m.isFinalExam)
            .some(
              (mod) =>
                mod.isLocked || mod.isLockedBySomeButNotAllStudentsInClass
            )
        ) {
          if (
            c.modules.filter((m) => !m.isFinalExam).every((mod) => mod.isLocked)
          ) {
            courseToAdd.isLocked = lockStatuses.locked;
          } else {
            courseToAdd.isLocked = lockStatuses.partiallyLocked;
          }
        }
        tempCoursesLockStatus.push(courseToAdd);
      });
      setCoursesLockStatus(tempCoursesLockStatus);
    }
  }, [courses, toggleUpdateCourseLockStatus]);

  const toggleModulesOpen = (courseId) => {
    if (modulesCollapseOpen.includes(courseId)) {
      setModulesCollapseOpen((prev) =>
        prev.filter((element) => {
          return element !== courseId;
        })
      );
    } else {
      setModulesCollapseOpen((prevstate) => [...prevstate, courseId]);
    }
  };

  const handleSetLockStatus = (
    moduleId,
    statusToSet,
    courseId,
    isSetFromPartial
  ) => {
    const postObject = {
      moduleId: moduleId,
      currentLevelId: currentLevelId,
      locked: statusToSet,
    };
    switch (level) {
      case "Class": {
        changeLockStatusForModuleForClass.mutate(postObject, {
          throwOnError: true,
          onSuccess: () => {
            let tempCoursesData = [...courses];
            tempCoursesData
              .find((c) => c.id === courseId)
              .modules.find((mod) => mod.moduleId === moduleId).isLocked =
              statusToSet;
            if (isSetFromPartial) {
              tempCoursesData
                .find((c) => c.id === courseId)
                .modules.find(
                  (mod) => mod.moduleId === moduleId
                ).isLockedBySomeButNotAllStudentsInClass = false;
            }
            queryClient.setQueryData(
              ["FetchCoursesByClassId", currentLevelId],
              tempCoursesData
            );
            setToggleUpdateCourseLockStatus(!toggleUpdateCourseLockStatus);
          },
          onError: (data) => {
            toast.warn(data.response.data);
          },
        });
        break;
      }
      case "Student": {
        changeLockStatusForModuleForStudent.mutate(postObject, {
          throwOnError: true,
          onSuccess: (data) => {
            let tempCoursesData = [...courses];
            tempCoursesData
              .find((c) => c.id === courseId)
              .modules.find((mod) => mod.moduleId === moduleId).isLocked =
              statusToSet;
            queryClient.setQueryData(
              ["FetchCoursesWithResultsByStudentId", currentLevelId],
              tempCoursesData
            );
            setToggleUpdateCourseLockStatus(!toggleUpdateCourseLockStatus);
          },
          onError: (data) => {
            toast.warn(data.response.data);
          },
        });
        break;
      }
      default: {
        return null;
      }
    }
  };
  const getModuleLockStatusText = (lockStatus) => {
    switch (lockStatus) {
      case "unlocked":
        return <FormattedMessage id="AllModulesUnlocked" />;
      case "locked":
        return <FormattedMessage id="AllModulesLocked" />;
      case "partiallyLocked":
        return <FormattedMessage id="SomeModulesLocked" />;
      default:
        return <></>;
    }
  };

  const lockStatusForCourse = (courseId) => {
    if (coursesLockStatus.length > 0) {
      let courseLockStatus = coursesLockStatus.find(
        (c) => c.courseId === courseId
      );
      return (
        <Col
          lg={12}
          className={
            "text-center class--lock--status--row class--lock--status--row-" +
            courseLockStatus.isLocked
          }
        >
          <h6 style={{ height: "25px", lineHeight: "25px" }}>
            {getModuleLockStatusText(courseLockStatus.isLocked)}
          </h6>
        </Col>
      );
    }
  };

  const mappedModules = (course) => {
    let courseModules = course.modules;
    const modulesWithCoupleId = courseModules.filter(
      (m) => m.moduleCoupleId != null
    );
    modulesWithCoupleId.forEach((testModule) => {
      if (testModule.qApiId != null && !testModule.isFinalExam) {
        const coupledModule = modulesWithCoupleId.find(
          (mod) =>
            mod.moduleId !== testModule.moduleId &&
            mod.moduleCoupleId === testModule.moduleCoupleId
        );
        if (coupledModule) {
          const mergedModule = {
            factModuleId: coupledModule.moduleId,
            name: coupledModule.name,
            testModuleId: testModule.moduleId,
            isMergedModules: true,
            testLocked: testModule.isLocked,
            factLocked: coupledModule.isLocked,
            testIsLockedBySomeButNotAllStudentsInClass:
              testModule.isLockedBySomeButNotAllStudentsInClass,
            factIsLockedBySomeButNotAllStudentsInClass:
              coupledModule.isLockedBySomeButNotAllStudentsInClass,
            sortOrder: coupledModule.sortOrder,
          };
          courseModules = courseModules.filter(
            (mod) =>
              mod.moduleId !== mergedModule.testModuleId &&
              mod.moduleId !== mergedModule.factModuleId
          );
          courseModules.push(mergedModule);
        }
      }
    });
    return courseModules
      .sort((a, b) => a.sortOrder - b.sortOrder)
      .map((mod, i) => {
        if (mod.isFinalExam) return null;

        if (mod.isMergedModules) {
          return (
            <Row
              key={mod.id ? "m" + mod.id : `merged-${i}`}
              className="mx-0 border align-content-center"
            >
              <Col className="pe-0 ps-2">{mod.name}</Col>
              <Col
                title={
                  mod.factIsLockedBySomeButNotAllStudentsInClass &&
                  level === "Class"
                    ? intl.formatMessage({
                        id: "ModuleUnlockedForSomeClickToLockForAll",
                      })
                    : mod.factLocked
                    ? intl.formatMessage({
                        id: "FactModuleLocked",
                      })
                    : intl.formatMessage({
                        id: "FactModuleUnlocked",
                      })
                }
                onClick={() =>
                  handleSetLockStatus(
                    mod.factModuleId,
                    mod.factIsLockedBySomeButNotAllStudentsInClass
                      ? true
                      : !mod.factLocked,
                    course.id,
                    mod.factIsLockedBySomeButNotAllStudentsInClass
                  )
                }
                lg={3}
                className={
                  mod.factIsLockedBySomeButNotAllStudentsInClass &&
                  level === "Class"
                    ? "lockModule--button--partiallyLocked align-content-center"
                    : mod.factLocked
                    ? "lockModule--button--locked align-content-center"
                    : "lockModule--button--unlocked align-content-center"
                }
              >
                <FontAwesomeIcon
                  icon="play-circle"
                  style={{ fontSize: "21px", marginTop: "2px" }}
                  color="#49b8df"
                />
                <FontAwesomeIcon
                  icon={
                    mod.factIsLockedBySomeButNotAllStudentsInClass &&
                    level === "Class"
                      ? "unlock"
                      : mod.factLocked
                      ? "lock"
                      : "lock-open"
                  }
                  style={{ marginTop: "3px" }}
                  className={"text-primary float-end"}
                  size="lg"
                />
              </Col>
              <Col
                title={
                  mod.factIsLockedBySomeButNotAllStudentsInClass &&
                  level === "Class"
                    ? intl.formatMessage({
                        id: "ModuleUnlockedForSomeClickToLockForAll",
                      })
                    : mod.factLocked
                    ? intl.formatMessage({
                        id: "TestLocked",
                      })
                    : intl.formatMessage({
                        id: "TestUnlocked",
                      })
                }
                onClick={() =>
                  handleSetLockStatus(
                    mod.testModuleId,
                    mod.testIsLockedBySomeButNotAllStudentsInClass
                      ? true
                      : !mod.testLocked,
                    course.id,
                    mod.testIsLockedBySomeButNotAllStudentsInClass
                  )
                }
                lg={3}
                className={
                  mod.testIsLockedBySomeButNotAllStudentsInClass &&
                  level === "Class"
                    ? "lockModule--button--partiallyLocked align-content-center"
                    : mod.testLocked
                    ? "lockModule--button--locked align-content-center"
                    : "lockModule--button--unlocked align-content-center"
                }
              >
                <svg
                  style={{
                    width: "21px",
                    marginTop: "-2px",
                  }}
                  id="Lager_2"
                  data-name="Lager 2"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 132 132"
                >
                  <g id="Lager_1-2" data-name="Lager 1">
                    <g>
                      <path
                        style={{
                          fill: "#49b8df",
                        }}
                        d="M91.96,48.7c-.21-.22-.46-.42-.72-.59-.09,0-.18-.02-.27-.06-.14-.06-.26-.16-.33-.29-.42-.2-.87-.33-1.32-.39-.39-.05-.66-.42-.61-.81.05-.39.42-.67.81-.61.45.07.89.18,1.32.35.07-.31.11-.63.11-.96,0-.71-.17-1.42-.52-2.09-.4-.77-.99-1.36-1.69-1.77-.61-.36-1.29-.57-1.99-.62-.05.64-.2,1.28-.47,1.9-.16.36-.58.53-.94.37-.36-.16-.53-.58-.38-.94.26-.6.38-1.21.38-1.82,0-.09,0-.17,0-.26-.05-.84-.33-1.66-.8-2.35-.48-.69-1.14-1.26-1.97-1.62-.6-.25-1.21-.37-1.82-.37-1.16,0-2.29.45-3.14,1.24.16.54.25,1.11.25,1.7,0,.4-.32.72-.72.72s-.72-.32-.72-.72c0-.58-.11-1.13-.3-1.64h0c-.33-.86-.92-1.61-1.67-2.13-.75-.52-1.65-.83-2.64-.83-.86,0-1.65.23-2.34.64-.55.32-1.02.76-1.39,1.28.73.99,1.16,2.22,1.16,3.55,0,.4-.32.72-.72.72s-.72-.32-.72-.72c0-1.16-.43-2.22-1.14-3.03-.85-.97-2.08-1.57-3.46-1.57-.96,0-1.84.29-2.58.79-.74.5-1.32,1.21-1.67,2.04-.22.54-.35,1.14-.35,1.77,0,.4-.32.72-.72.72s-.72-.32-.72-.72c0-.58.08-1.14.24-1.68-.54-.22-1.13-.34-1.73-.34-.34,0-.68.04-1.03.12-1.02.24-1.88.79-2.5,1.53-.45.54-.77,1.18-.94,1.86,1.48.03,2.96.6,4.11,1.72.28.28.29.73.01,1.01-.28.28-.73.29-1.01.01-.9-.88-2.06-1.31-3.22-1.32-.21,0-.42.01-.62.04h0c-.98.14-1.92.58-2.66,1.34-.88.9-1.31,2.05-1.31,3.22,0,.67.15,1.34.43,1.95.23.49.54.94.95,1.34h0c.46.45.99.79,1.56,1.01.37.14.55.56.41.93-.14.37-.56.56-.93.41-.74-.29-1.44-.73-2.05-1.32-.26-.26-.5-.54-.71-.83-.54.78-.84,1.7-.84,2.65,0,.73.18,1.47.55,2.17.42.78,1.02,1.38,1.73,1.8.56.33,1.19.53,1.83.61v-.04c0-.38.03-.75.1-1.11.07-.39.45-.64.84-.57.39.07.65.45.58.84-.05.28-.08.56-.08.85,0,.11,0,.22.01.33,0,.12.02.23.04.34h0s0,.01,0,.01c.33,2.25,2.27,3.93,4.55,3.93.11,0,.22,0,.33-.01h0c1.01-.07,1.92-.46,2.63-1.07.5-.43.92-.96,1.2-1.56.17-.36.6-.51.96-.34.36.17.51.6.34.95-.31.65-.73,1.23-1.23,1.73.28.87.81,1.61,1.5,2.16.79.63,1.79,1.01,2.87,1.01.11,0,.22,0,.33-.01h0c.68-.05,1.31-.24,1.87-.55-.09-.41-.14-.83-.14-1.26,0-.88.2-1.78.6-2.62.17-.36.6-.51.96-.33.36.17.51.6.34.96-.31.65-.46,1.33-.46,2,0,.47.07.94.21,1.38h0c.37,1.17,1.2,2.19,2.39,2.77.65.31,1.33.46,1.99.46,1.06,0,2.1-.37,2.93-1.04h0c.5-.41.92-.94,1.22-1.56h0c.28-.58.43-1.19.45-1.8.02-.4.35-.7.75-.68.4.02.7.35.68.75-.03.8-.23,1.6-.6,2.36h0c-.29.61-.68,1.16-1.14,1.62.85,1.21,2.25,1.98,3.77,1.98.28,0,.57-.03.86-.08,1.11-.21,2.04-.79,2.71-1.6.66-.81,1.05-1.83,1.05-2.92,0-.03,0-.07,0-.1h0c0-.25-.03-.5-.08-.76-.11-.61-.35-1.16-.67-1.65-.46-.41-.98-.94-1.47-1.53-.52-.63-.99-1.32-1.31-2.02-.21-.47-.36-.94-.36-1.43,0-.22.03-.45.11-.67.08-.22.21-.43.39-.61.28-.28.73-.28,1.01,0,.28.28.28.74,0,1.02-.03.03-.04.05-.05.09-.02.04-.03.09-.03.17,0,.18.07.49.23.84.16.35.4.74.68,1.13.56.78,1.28,1.54,1.82,2.01l.07.06.05.08c.44.66.77,1.42.93,2.25h0c.02.12.04.24.05.36.07,0,.14,0,.21,0,.91,0,1.82-.27,2.63-.84.64-.45,1.13-1.03,1.46-1.68.33-.65.5-1.37.5-2.09,0-.68-.15-1.36-.46-1.99-.28.09-.57.16-.86.21-.39.07-.76-.2-.83-.58-.07-.39.2-.76.59-.83,1.27-.22,2.43-.96,3.15-2.15.46-.75.67-1.57.67-2.38,0-1.2-.46-2.37-1.32-3.24h0ZM59.1,43.22c.68-.81,1.59-1.39,2.57-1.76.98-.38,2.03-.56,3.04-.56.98,0,1.92.17,2.73.54.36.16.52.59.35.95-.16.36-.59.52-.95.35-.55-.26-1.31-.41-2.12-.41s-1.73.15-2.53.47c-.8.31-1.5.77-2,1.35-.25.3-.71.34-1.01.08-.3-.26-.34-.71-.08-1.01ZM75.42,60.18c-.83,0-1.59-.09-2.28-.25.02.2.03.42.03.65,0,.47-.05,1-.2,1.56-.15.56-.4,1.15-.79,1.71-.23.33-.67.41-1,.18-.33-.23-.41-.67-.18-1,.29-.42.47-.84.58-1.26.11-.42.15-.83.15-1.2,0-.51-.08-.92-.13-1.16-.35-.16-.67-.34-.97-.53-1.2-.78-2.01-1.8-2.51-2.78-.34-.65-.54-1.29-.65-1.84-.06-.31-.1-.6-.1-.86,0-.4.32-.72.72-.72s.72.32.72.72c0,.21.04.56.16.95.11.4.29.85.55,1.3.52.91,1.35,1.83,2.64,2.42.86.4,1.92.66,3.26.66.4,0,.72.32.72.72,0,.4-.32.72-.72.72ZM80.47,54.95c-.15.37-.57.55-.93.4-.37-.15-.54-.56-.4-.93h0s0-.01,0-.01c0-.01.01-.03.02-.06.02-.06.05-.15.07-.26.05-.23.11-.55.11-.9v-.05c-.99.33-1.9.48-2.74.48-1.27,0-2.37-.35-3.27-.88-.9-.53-1.6-1.23-2.12-1.94-.59-.81-1.37-1.53-2.26-2.04-.89-.51-1.89-.82-2.95-.82-.93,0-1.92.23-2.95.8-.98.54-1.61,1.25-2.02,2.04-.4.79-.58,1.65-.57,2.43,0,.72.15,1.38.35,1.79.17.36.02.79-.34.96s-.79.02-.96-.34c-.31-.66-.49-1.49-.49-2.41,0-.91.18-1.9.63-2.85-.89.2-1.72.29-2.47.29-.41,0-.79-.03-1.16-.07-.02.1-.07.19-.13.27h0s-.01.01-.01.01c0,.01-.02.03-.04.05-.04.04-.09.12-.15.21-.13.19-.31.46-.51.81-.39.69-.84,1.66-1.06,2.75-.08.39-.45.64-.84.56-.39-.08-.64-.45-.56-.85.26-1.3.77-2.4,1.21-3.18.23-.41.44-.73.6-.95-.59-.18-1.09-.39-1.5-.61-.94-.5-1.44-1.01-1.48-1.05-.27-.29-.27-.74.02-1.01.29-.27.74-.27,1.01.02h0s.04.05.04.05c.04.04.11.1.21.17.19.15.48.35.86.56.77.41,1.93.82,3.48.82,1.09,0,2.37-.21,3.87-.78.38-.35.81-.67,1.31-.95,1.23-.67,2.46-.98,3.64-.98,1.34,0,2.59.39,3.67,1.01,1.08.62,2,1.48,2.7,2.44.43.58.99,1.14,1.69,1.55.7.41,1.53.68,2.54.68.69,0,1.48-.13,2.36-.44-.22-.35-.54-.68-1.07-.98-.35-.2-.47-.63-.27-.98.2-.35.63-.47.98-.27.85.48,1.42,1.11,1.75,1.78.33.66.43,1.33.43,1.9,0,.99-.29,1.71-.31,1.76ZM80.2,46.16c-1.68,0-3.14-.45-4.33-1.14-.17.23-.39.52-.68.84-.65.71-1.6,1.55-2.88,2.01-.38.13-.78-.06-.92-.43-.13-.37.06-.78.43-.92.94-.34,1.73-1,2.28-1.59.25-.27.45-.53.59-.73-.71-.6-1.27-1.28-1.65-1.98-.36-.67-.57-1.36-.58-2.04,0-.4.32-.72.72-.72s.72.32.72.72c0,.36.12.85.4,1.35.28.51.69,1.04,1.24,1.51,1.1.95,2.68,1.68,4.65,1.68.4,0,.72.32.72.72,0,.4-.32.72-.72.72ZM85.86,56.26c-.25.3-.7.35-1.01.09-.31-.25-.35-.7-.1-1.01.78-.95,1.07-1.91,1.07-2.82,0-.83-.25-1.64-.65-2.32-.4-.68-.94-1.22-1.47-1.52-.35-.2-.68-.29-.95-.29-.4,0-.72-.32-.72-.72s.32-.72.72-.72c.44,0,.86.11,1.27.29.4.18.79.43,1.14.74.71.61,1.31,1.45,1.69,2.43.25.65.4,1.37.4,2.12,0,1.23-.42,2.55-1.4,3.74Z"
                      />
                      <path
                        style={{
                          fill: "#49b8df",
                        }}
                        d="M66,0C29.55,0,0,29.55,0,66s29.55,66,66,66,66-29.55,66-66S102.45,0,66,0ZM100.91,60.06c-1.43,17.05-9.89,21.48-15.09,29.79-1.43,2.29-2.19,7.29-2.19,9.48v7.67h-32.08v-11.31c0-.74-.32-1.45-.87-1.95-.55-.5-1.29-.73-2.04-.65l-3.79-.3c-1.38.15-2.76-.28-3.8-1.19-1.05-.91-1.66-2.22-1.7-3.6l-1.49-14.39-4.75-1.31c-.82-.16-1.52-.71-1.87-1.48-.35-.76-.31-1.65.1-2.38l7.68-13.57v-1.64c-.32-18.13,14.57-29.25,32.25-28.16,20.89,1.29,31.07,17.93,29.64,34.99Z"
                      />
                    </g>
                  </g>
                </svg>
                <FontAwesomeIcon
                  icon={
                    mod.testIsLockedBySomeButNotAllStudentsInClass &&
                    level === "Class"
                      ? "unlock"
                      : mod.testLocked
                      ? "lock"
                      : "lock-open"
                  }
                  style={{ marginTop: "3px" }}
                  className={"text-primary float-end"}
                  size="lg"
                />
              </Col>
            </Row>
          );
        }

        if (mod.isFactModule) {
          return (
            <Row
              key={mod.moduleId ? "fact-no-test" + mod.moduleId : `row-${i}`}
              className="mx-0 border align-content-center"
            >
              <Col className="pe-0 ps-2">{mod.name}</Col>
              <Col
                title={
                  mod.isLockedBySomeButNotAllStudentsInClass &&
                  level === "Class"
                    ? intl.formatMessage({
                        id: "ModuleUnlockedForSomeClickToLockForAll",
                      })
                    : mod.isLocked
                    ? intl.formatMessage({ id: "FactModuleLocked" })
                    : intl.formatMessage({ id: "FactModuleUnlocked" })
                }
                onClick={() =>
                  handleSetLockStatus(
                    mod.moduleId,
                    mod.isLockedBySomeButNotAllStudentsInClass
                      ? true
                      : !mod.isLocked,
                    course.id,
                    mod.isLockedBySomeButNotAllStudentsInClass
                  )
                }
                lg={3}
                className={
                  mod.isLockedBySomeButNotAllStudentsInClass &&
                  level === "Class"
                    ? "lockModule--button--partiallyLocked align-content-center"
                    : mod.isLocked
                    ? "lockModule--button--locked align-content-center"
                    : "lockModule--button--unlocked align-content-center"
                }
              >
                <FontAwesomeIcon
                  icon="play-circle"
                  style={{
                    fontSize: "21px",
                    marginTop: "2px",
                  }}
                  color="#49b8df"
                />
                <FontAwesomeIcon
                  icon={
                    mod.isLockedBySomeButNotAllStudentsInClass &&
                    level === "Class"
                      ? "unlock"
                      : mod.isLocked
                      ? "lock"
                      : "lock-open"
                  }
                  className={"text-primary float-end"}
                  style={{ marginTop: "3px" }}
                  size="lg"
                />
              </Col>
              <Col lg={3}></Col>
            </Row>
          );
        }

        return (
          <Fragment
            key={mod.moduleId ? "lockModule" + mod.moduleId : `frag-${i}`}
          >
            {mod.isLockedBySomeButNotAllStudentsInClass && level === "Class" ? (
              <CTooltip
                content={intl.formatMessage({
                  id: "ModuleUnlockedForSomeClickToLockForAll",
                })}
                placement="top"
              >
                <Row
                  className={
                    "lockModule--button--partiallyLocked mx-0 border py-1"
                  }
                  onClick={() =>
                    handleSetLockStatus(mod.moduleId, true, course.id, true)
                  }
                >
                  <Col className="pe-0 ps-2">{mod.name}</Col>
                  <Col lg={3}>
                    <FontAwesomeIcon
                      icon="unlock"
                      className={"text-primary float-end"}
                      size="lg"
                    />
                  </Col>
                </Row>
              </CTooltip>
            ) : (
              <Row
                key={mod.moduleId ? "lockModule" + mod.moduleId : `row-${i}`}
                className={
                  mod.isLocked
                    ? "lockModule--button--locked mx-0 border py-1"
                    : "lockModule--button--unlocked mx-0 border py-1"
                }
                onClick={() =>
                  handleSetLockStatus(mod.moduleId, !mod.isLocked, course.id)
                }
              >
                <Col className="pe-0 ps-2">{mod.name}</Col>
                <Col
                  lg={3}
                  style={!mod.isLocked ? { paddingRight: "0.8em" } : {}}
                >
                  {mod.isLocked ? (
                    <FontAwesomeIcon
                      icon="lock"
                      className={
                        mod.isLocked
                          ? "text-muted float-end"
                          : "text-primary float-end"
                      }
                      size="lg"
                    />
                  ) : (
                    <FontAwesomeIcon
                      className={
                        mod.isLocked
                          ? "text-muted float-end"
                          : "text-primary float-end"
                      }
                      icon="lock-open"
                      size="lg"
                    />
                  )}
                </Col>
              </Row>
            )}
          </Fragment>
        );
      });
  };

  const handleSetLockCompleteCourseForAll = (lock, courseId) => {
    setCoursesLoadingLock([...coursesLoadingLock, courseId]);
    const postObject = {
      courseId: courseId,
      locked: lock,
      studentIds: students,
    };
    changeLockStatusForEntireCourseForMultipleStudents.mutate(postObject, {
      throwOnError: true,
      onSuccess: () => {
        let tempCoursesData = [...courses];
        let tempCourse = tempCoursesData.find((c) => c.id === courseId);
        tempCourse.modules.forEach((mod) => {
          mod.isLocked = lock;
          mod.isLockedBySomeButNotAllStudentsInClass = false;
        });

        queryClient.setQueryData(
          ["FetchCoursesWithResultsByStudentId", currentLevelId],
          tempCoursesData
        );
        setToggleUpdateCourseLockStatus(!toggleUpdateCourseLockStatus);
        setCoursesLoadingLock((prevState) =>
          prevState.filter((c) => c !== courseId)
        );
      },
      onError: (data) => {
        toast.warn(data.response.data);
      },
    });
  };

  const mappedCourses = () => {
    if (courses) {
      const addedCourses = [];
      return courses.map((course, i) => {
        if (!addedCourses.find((c) => c.id === course.id)) {
          addedCourses.push(course);
          return (
            <Fragment key={"courseLockerCard" + course.id}>
              <Card style={{ marginBottom: "11px" }}>
                <Row
                  className="mx-0"
                  style={{
                    minHeight: "25px",
                  }}
                >
                  {lockStatusForCourse(course.id)}
                </Row>
                <CardImg
                  top
                  style={{
                    width: "100%",
                    height: "10vw",
                    objectFit: "cover",
                    cursor: "pointer",
                    marginTop: "-25px",
                  }}
                  src={course.imgUrl}
                  alt="Card image cap"
                  className="mb-0 img-fluid"
                  onClick={() => toggleModulesOpen(course.id)}
                />
                <Row
                  className="mx-0"
                  style={{
                    minHeight: "30px",
                    marginTop: "-30px",
                    backgroundColor: "rgba(255,255,255,.6)",
                  }}
                >
                  {coursesLoadingLock.includes(course.id) ? (
                    <Col
                      className="d-flex justify-content-center"
                      style={{ marginTop: "5px" }}
                    >
                      <BeatLoader color={"#20a8d8"} size={14} loading={true} />
                    </Col>
                  ) : (
                    <>
                      <Col
                        lg={6}
                        className="py-1 lockModule--button--locked text-center"
                        onClick={() =>
                          handleSetLockCompleteCourseForAll(true, course.id)
                        }
                      >
                        <FontAwesomeIcon
                          icon="lock"
                          size="lg"
                          className="text-muted me-2"
                        />
                        <FormattedMessage id="LockAll" />
                      </Col>
                      <Col
                        lg={6}
                        style={{ paddingRight: "0.8em" }}
                        className="py-1 lockModule--button--unlocked text-center"
                        onClick={() =>
                          handleSetLockCompleteCourseForAll(false, course.id)
                        }
                      >
                        <FontAwesomeIcon
                          icon="lock-open"
                          size="lg"
                          className="text-primary me-2"
                        />
                        <FormattedMessage id="UnlockAll" />
                      </Col>
                    </>
                  )}
                </Row>

                <div onClick={() => toggleModulesOpen(course.id)}>
                  <div
                    className="lead text-center"
                    style={{ cursor: "pointer" }}
                  >
                    <FontAwesomeIcon
                      style={{ marginRight: "1em" }}
                      icon={
                        modulesCollapseOpen.includes(course.id)
                          ? "caret-down"
                          : "caret-up"
                      }
                    />
                    {course.courseName}
                  </div>
                </div>

                <Collapse isOpen={modulesCollapseOpen.includes(course.id)}>
                  {mappedModules(course)}
                </Collapse>
              </Card>
            </Fragment>
          );
        } else {
          return null;
        }
      });
    }
  };

  return (
    <Col lg={12}>
      <Card>
        <CardBody>
          <CardTitle
            onClick={() => setCollapsed(!collapsed)}
            style={{ cursor: "pointer" }}
          >
            <FontAwesomeIcon
              style={{ marginRight: ".5em" }}
              className={
                collapsed
                  ? "fa-caret--animated"
                  : "fa-caret--animated collapsed"
              }
              icon={"caret-up"}
            />
            <FormattedMessage id="LockAndUnlockModules" />
            <small className="faded">
              {" "}
              (<FormattedMessage id="NotFinalExam" />)
            </small>
            <hr />
          </CardTitle>
          <Collapse isOpen={!collapsed}>
            <Row>
              <div
                className="modules-lock-cards_container w-100"
                style={{ margin: "16px 26px 0 26px" }}
              >
                {mappedCourses()}
              </div>
            </Row>
          </Collapse>
        </CardBody>
      </Card>
    </Col>
  );
};
export default injectIntl(ModuleLocker);
